import { Button, Grid, Stack, Typography } from '@mui/material';
import { useGetRollupNamespaces } from 'pages/admin/CostDashboard/hooks';
import { AllBusinessCostSummaryFilter } from 'pages/admin/CostDashboard/hooks/useGetAllBusinessSummaries';
import { BusinessCostSummaryFilter } from 'pages/admin/CostDashboard/hooks/useGetBusinessCostSummary';
import React, { useEffect, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { FormSelectField, FormTextFieldBase } from 'shared/components/form';

interface ICostAnalysisFilter extends AllBusinessCostSummaryFilter {
  setBusinessCostAnalysisFilter: React.Dispatch<React.SetStateAction<AllBusinessCostSummaryFilter>>;
}

const CostAnalysisFilter: React.FC<ICostAnalysisFilter> = ({
  endTime,
  namespace,
  setBusinessCostAnalysisFilter,
  startTime,
}) => {
  const { data: namespaceList } = useGetRollupNamespaces();

  const form = useForm<BusinessCostSummaryFilter>({
    defaultValues: {
      startTime,
      endTime,
      namespace,
    },
  });

  useEffect(() => {
    if (namespaceList?.namespace?.length && !form.getValues('namespace')) {
      form.setValue('namespace', namespaceList.namespace[0]);
    }
  }, [namespaceList, form]);

  const namespaceListOptions = useMemo(() => {
    if (!namespaceList) return [];

    return [
      ...namespaceList.namespace.map(namespace => ({
        label: namespace,
        value: namespace,
      })),
    ];
  }, [namespaceList]);

  const handleApply = () => {
    const values = form.getValues();

    setBusinessCostAnalysisFilter({
      startTime: values.startTime,
      endTime: values.endTime,
      namespace: values.namespace,
    });
  };

  return (
    <FormProvider {...form}>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Stack>
              <Typography>Namespace</Typography>

              <FormSelectField fieldConfig={{ name: 'namespace' }} items={namespaceListOptions} />
            </Stack>
          </Grid>

          <Grid item xs={3}>
            <Stack>
              <Typography>Start Date</Typography>

              <FormTextFieldBase
                fieldConfig={{
                  name: 'startTime',
                  label: 'Start Time',
                }}
                type="date"
              />
            </Stack>
          </Grid>

          <Grid item xs={3}>
            <Stack>
              <Typography>End Date</Typography>

              <FormTextFieldBase
                fieldConfig={{
                  name: 'endTime',
                  label: 'End Time',
                }}
                type="date"
              />
            </Stack>
          </Grid>

          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
              pb: 1,
            }}
            xs={3}
          >
            <Button onClick={handleApply}>Apply</Button>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};

export default CostAnalysisFilter;
